/** `GET /dues` (workers/api/src/billing/dues.ts): who owes what, gated on `billing.dues` alone (D57, slice 6). */
import type { ApiClient } from "./client";

/** One bill still owing money. Only what a dues list needs; never the bill's total, tax or payments. */
export interface DueRow {
  billId: string; memberId: string; branchId: string; buyerName: string | null;
  businessDate: string; dueDate: string | null; balance: number;
}
export interface DuesResponse {
  currency: string;
  dues: DueRow[];
  /** Over the whole filter, computed by the server, never summed from the page. */
  totals: { count: number; balance: number };
  /** The page stopped before the last row. */
  capped: boolean;
}

export const DUES_LIMIT = 200;

export function fetchDues(c: ApiClient, q: { branchId?: string; limit?: number } = {}) {
  const p = new URLSearchParams({ limit: String(q.limit ?? DUES_LIMIT) });
  if (q.branchId) p.set("branchId", q.branchId);
  return c.get<DuesResponse>(`/dues?${p.toString()}`);
}
